import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog} from '@angular/material/dialog';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { UtilsService } from 'src/app/shared/utils.service';
import { AlertDialogComponent } from 'src/app/shared/alert-dialog/alert-dialog.component';
import {DataService} from "../../../shared/data.service";

@Component({
    selector: 'app-renew-subscriptions',
    templateUrl: './renew-subscriptions.component.html',
    styleUrls: ['./renew-subscriptions.component.scss'],
    standalone: false
})
export class RenewSubscriptionsComponent implements OnInit {
  renewSubscriptionForm: FormGroup;
  id: number;

  constructor(public dialog: MatDialog, public utils: UtilsService,
              private dataService: DataService, @Inject(MAT_DIALOG_DATA) public data: any) {
    this.id = data.id;
  }

  ngOnInit(): void {
    this.utils.setTitle('Renew Subscriptions');
    this.renewSubscriptionForm = new FormGroup({
      promotionCode: new FormControl(null, [Validators.required, this.utils.noWhitespaceValidator.bind(this)]),
    });
  }

  closeDialog() {
    if (this.renewSubscriptionForm.dirty) {
      const dialogRef = this.dialog.open(AlertDialogComponent, {
        disableClose: true,
        width: '400px',
        data: {
          title: 'Warning',
          type: 'Warn',
          message: 'You will miss your information once you close',
          buttonText: 'cancel',
          numberOfButtons: 2,
          seconButtonText: 'Ok'
        }
      });
      dialogRef.afterClosed().subscribe((status) => {
        if (status === 'Ok') {
          this.dialog.closeAll();
        }
      });
    } else {
      this.dialog.closeAll();
    }
  }

  onSubmit(){
    const payload = {
      Id: parseInt(this.id.toString(), 10),
      PromotionCode: this.renewSubscriptionForm.controls.promotionCode.value
    };
    this.dataService.put('distributor/EditSalesRepresentativePromotionCode', payload).then((data) => {
      if (data.statusCode === 200) {
        const dialogRef = this.dialog.open(AlertDialogComponent, {
          disableClose: true,
          width: '400px',
          data: {
            title: 'Success',
            type: 'Success',
            message: 'Promotion Code changed successfully',
            buttonText: 'Ok'
          }
        });

      }else if (data.statusCode === 625){
        const dialogRef = this.dialog.open(AlertDialogComponent, {
          disableClose: true,
          width: '400px',
          data: {
            title: 'Error',
            type: 'Error',
            message: 'Promotional Code not Correct/Available. Please enter a new Code!',
            buttonText: 'Ok'
          }
        });
      } else {
        const dialogRef = this.dialog.open(AlertDialogComponent, {
          disableClose: true,
          width: '400px',
          data: {
            title: 'Error',
            type: 'Error',
            message: 'Something went wrong, Please try again!',
            buttonText: 'Ok'
          }
        });
      }
    });
  }

}
